import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { captureException } from 'r/utils';
import { fetchApiRaw, GET_ISSUERS } from 'r/utils/fetchApiRaw';
import type { IssuerWithPerformanceMetrics } from 'r/types';
import { buildFilterString, type FilterCondition } from './utils';

export const adminAuthorFiltersAtom = atom({
  search: '',
  showLeaderboardOnly: false,
  sortBy: 'createdAt:desc',
  page: 0,
  limit: 50,
});

export const adminAuthorsQueryAtom = atomWithQuery((get) => {
  const filters = get(adminAuthorFiltersAtom);

  return {
    queryKey: [
      'admin-authors-list',
      filters.page,
      filters.limit,
      filters.search,
      filters.showLeaderboardOnly,
      filters.sortBy,
    ],
    queryFn: async () => {
      try {
        const filterConditions: Record<string, FilterCondition> = {};

        if (filters.showLeaderboardOnly) {
          filterConditions['adminInfo.isKol'] = true;
        }

        if (filters.search.trim()) {
          const searchPattern = `%${filters.search.trim()}%`;
          filterConditions.$or = [
            { username: { $ilike: searchPattern } },
            { twitter: { $ilike: searchPattern } },
          ];
        }

        const queryParams: Record<string, string> = {
          skip: String(filters.page * filters.limit),
          take: String(filters.limit),
        };

        if (filters.sortBy) {
          queryParams.sort = filters.sortBy;
        }

        if (Object.keys(filterConditions).length > 0) {
          queryParams.filter = buildFilterString(filterConditions);
        }

        const response = await fetchApiRaw(GET_ISSUERS, { queryParams });

        return {
          data:
            Array.isArray(response.data) ?
              (response.data as IssuerWithPerformanceMetrics[])
            : [],
          total: response.total || 0,
        };
      } catch (e) {
        captureException(e);
        return { data: [], total: 0 };
      }
    },
    keepPreviousData: true,
  };
});
